module.exports = __webpack_public_path__ + "static/img/android4.602480f7.jpg";